import { startTransition, StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

startTransition(() => {
  // Hydrate the React app on the client, attaching event listeners to the server-rendered HTML.
  // Passing the entire document is required for Remix's hydration strategy
  ReactDOM.hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
